import { Component, Input, OnInit, ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-grafico-linea',
  templateUrl: './grafico-linea.component.html',
  styleUrls: ['./grafico-linea.component.scss']
})
export class GraficoLineaComponent implements OnInit {
  @Input() data = {};
  @ViewChild('canvas', {static: false}) canvas: any;

  public context: CanvasRenderingContext2D;

  chart: any
  labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']
  dataG = [65, 59, 80, 81, 56, 55, 40]
  coloR = []

  constructor() {
  }

  ngOnInit(): void {
    this.context = this.canvas.nativeElement.getContext('2d');
    this.chart = new Chart(this.context, {
      type: 'line',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          data: [65, 59, 80, 81, 56, 55, 40],
          borderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1
        }
      ]
      },
      options: {
        scales: {
            y: {
                stacked: true,
            }
        }
      }
    });
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  async ngOnChanges(changes: SimpleChanges) {
    
    setTimeout(async ()=>{
      console.log(changes.data.currentValue.data[0])
      if('tiempo' in changes.data.currentValue.data[0]){
        // Extract unique categories from the data
        const uniqueCategories = (changes.data.currentValue.data.map(item => item.column1)).filter((value, index, array) => array.indexOf(value) === index);
        const groupedData = changes.data.currentValue.data.reduce((acc, cur) => {
            const existingEntry = acc.find(item => item.tiempo === cur.tiempo);

            if (existingEntry) {
                existingEntry[cur.column1].push(cur.column2);
            } else {
                const newEntry = {
                    time: cur.tiempo,
                    [cur.column1]: cur.column2
                };
                acc.push(newEntry);
            }

            return acc;
        }, []);

        // Prepare datasets for Chart.js
        const datasets = uniqueCategories.map(category => {
          const color = this.dynamicColors();
          return {
              label: category,
              data: groupedData.map(item => item[category] || 0),
              fill: true,
              borderColor: color,
              backgroundColor: color
          };
        });
          this.chart.data.labels = (groupedData.map(item => item.time)).filter((value, index, array) => array.indexOf(value) === index);
          this.chart.data.datasets = datasets
        this.chart.update();
      }
    },500)
  }

}
